import React from 'react';
import {Card, CardHeader, CardMedia, CardText} from 'material-ui/Card';
import Chip from 'material-ui/Chip';
import Avatar from 'material-ui/Avatar';

const styles = {
  card:{
    margin:8,
  },
  cardheader:{
    padding:8,
    paddingBottom:0,
  },
  maintext:{
    paddingTop:0,
    paddingBottom:0,
  },
  chip: {
    margin: 4,
    backgroundColor:"rgb(240,240,240)"
  },
  wrapper: {
    display: 'flex',
    flexWrap: 'wrap',
  },
};

export default class EducationIdaho extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      expanded: false,
    };
  }

  handleExpandChange = (expanded) => {
    this.setState({expanded: expanded});
  };

  handleToggle = (event, toggle) => {
    this.setState({expanded: toggle});
  };

  handleExpand = () => {
    this.setState({expanded: true});
  };

  handleReduce = () => {
    this.setState({expanded: false});
  };

  render() {
    return (
      <Card
        expanded={this.state.expanded}
        onExpandChange={this.handleExpandChange}
        style={styles.card}
      >
        <CardHeader
          title="University of Idaho"
          subtitle="B.S. Mechanical Engineering: 1997­-2002, 3.9 GPA"
          avatar="images/idaho.jpg"
          actAsExpander={true}
          showExpandableButton={this.props.showCarrot}
          style={styles.cardheader}
        />
        <CardText
          style={styles.maintext}
        >
          <ul>
            <li>Co­-founder and Team Captain for 2000-2001 Formula SAE at the University of Idaho</li>
            <li>Formula SAE is a collegiate competition involving the design, construction, testing, and
              competing of small formula-­style race cars from scratch.</li>
            <li>
              Relevant classes/experience:
              <div style={styles.wrapper}>
                <Chip style={styles.chip}>
                  <Avatar size={32}>S02</Avatar>
                  Fracture Mechanics
                </Chip>
                <Chip style={styles.chip}>
                  <Avatar size={32}>S02</Avatar>
                  Material Selection
                </Chip>
                <Chip style={styles.chip}>
                  Pro/E
                </Chip>
                <Chip style={styles.chip}>
                  TIG Welding
                </Chip>
                <Chip style={styles.chip}>
                  Mill/Lathe
                </Chip>
              </div>
            </li>
          </ul>

        </CardText>
        <CardMedia
          expandable={true}
        >
          <img src="images/fsae.jpg" alt="" />
        </CardMedia>
        <CardText expandable={true}>
          <ul>
            <li>Fundraising: >$15,000 in sponsorship</li>
            <li>Rookie of the year award in 2001 (28th of 123 teams)</li>
            <li>Solid Modeling: Designed from scratch using Pro/E</li>
            <li>Fabrication: Built from scratch using machining, TIG welding</li>
          </ul>
        </CardText>
      </Card>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/EducationIdaho.js